<template>
  <v-row justify="center">


    <v-dialog
      v-model="show"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline text-h2" style="word-break:normal;">
          <template v-if="notepadMulti">
            Artikel {{ notepadSelectedArticles }} wurden zum Merkzettel hinzugefügt.
          </template>
          <template v-if="!notepadMulti">
            Artikel {{ notepadCurrentArticle.number }} wurde zum Merkzettel hinzugefügt.
          </template>

        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            text
            @click="show = false"
          >
            Weiter
          </v-btn>

          <v-btn
            :href="notepadUrl"
            target="_blank"
            color="primary"
            text
            @click="show = false"
          >
            Zum Merkzettel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    value: Boolean,
    notepadUrl: String,
    notepadCurrentArticle: {
      type: Object,
      default: function () {
        return { }
      }
    },
    notepadSelectedArticles: {
      type: String,
      default: ''
    },
    notepadMulti: {
      type: Boolean
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
